import Bottleneck from "bottleneck";

//
export const solanaLimiter = new Bottleneck({
  // Starting amount.
  reservoir: 20,
  // Amount by which we refill reservoir.
  reservoirRefreshAmount: 20,
  // Interval after which we refill reservoir.
  reservoirRefreshInterval: 10 * 1_000,
  maxConcurrent: 20,
});
